import styled from 'styled-components'
import { BodyMedium, HeadLine1 } from '../../components/typography/styled'

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin: 10px 0;
`

export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
`

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  min-height: 40px;

  @media (max-width: 560px) {
    align-items: stretch;
  }
`

export const SearchField = styled.div`
  flex: 1 1 320px;
  min-width: 200px;
  min-height: 40px;

  > div {
    height: 40px;
  }

  > div > div:first-child {
    position: relative;
    top: 0;
  }
`

export const FilterActions = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  margin-left: auto;

  @media (max-width: 560px) {
    width: 100%;
    justify-content: flex-end;
  }
`

export const FilterSelect = styled.div`
  flex: 1 1 220px;
  width: 100%;
  min-width: 190px;
  max-width: 280px;

  @media (max-width: 720px) {
    flex: 1 1 100%;
    max-width: none;
  }
`

export const ListPage = styled.div`
  min-width: 0;

  > div {
    min-width: 0;
  }

  > div > div:last-child {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow-x: auto;
  }

  table {
    min-width: 960px;
  }

  @media (max-width: 720px) {
    > div {
      padding-right: 16px;
      padding-left: 16px;
    }
  }
`

export const Status = styled(BodyMedium)<{ status?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: ${({ status, theme }) => {
    if (status === 'online' || status === 'active') return '#229B61'
    if (status === 'rebooting') return '#C48100'
    if (status === 'offline' || status === 'disabled' || status === 'deleted') return theme.errors[600]
    return theme.palette[600]
  }};
`

export const StatusDot = styled.span<{ status?: string }>`
  width: 9px;
  height: 9px;
  flex: 0 0 9px;
  border-radius: 50%;
  background: ${({ status, theme }) => {
    if (status === 'online' || status === 'active') return '#229B61'
    if (status === 'rebooting') return '#C48100'
    if (status === 'offline' || status === 'disabled' || status === 'deleted') return theme.errors[600]
    return theme.palette[600]
  }};
`

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 10px 20px 30px 30px;
  box-sizing: border-box;

  @media (max-width: 720px) {
    padding: 10px 16px 24px;
  }
`

export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin: 10px 10px 20px 0;
`

export const DetailTitle = styled(HeadLine1)`
  color: ${({ theme }) => theme.palette[800]};
  overflow-wrap: anywhere;
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  gap: 12px;
  margin-right: 10px;
  align-items: start;

  > div {
    width: auto;
    min-width: 0;
  }

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const RawData = styled.pre`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: auto;
  max-height: 520px;
  margin: 0;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.grey[350]};
  border-radius: 8px;
  color: ${({ theme }) => theme.palette[800]};
  background: ${({ theme }) => theme.palette[20]};
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`
